const CheckBuildNumberStateKey = 'system.checkBuildNumberState';

interface CheckBuildNumberState {
    lastAttempt: number; // Date.now()
}

function getCheckBuildNumberState(): CheckBuildNumberState {
    let state: CheckBuildNumberState;
    try {
        state = JSON.parse(sessionStorage.getItem(CheckBuildNumberStateKey));
    } catch (e) {}
    state = state || { lastAttempt: 0 };
    return state;
}

function saveCheckBuildNumberState(state: CheckBuildNumberState): void {
    sessionStorage.setItem(CheckBuildNumberStateKey, JSON.stringify(state));
}

function attemptReload(
    state: CheckBuildNumberState,
    current: string,
    next: string,
): boolean {
    if (Date.now() - state.lastAttempt < 60000) {
        return false;
    }

    state.lastAttempt = Date.now();

    return current !== next;
}

export function checkBuildNumber(next: string): void {
    if (CMPS_APP_DEF.ENV !== 'prod') {
        return;
    }

    const state = getCheckBuildNumberState();

    if (attemptReload(state, next, CMPS_APP_DEF.BUILD)) {
        saveCheckBuildNumberState(state);

        location.reload();
    }
}
